import { NgModule } from '@angular/core';
import { MainNotificationComponent } from './main-notification/main-notification.component';

@NgModule({
  imports: [MainNotificationComponent],
  exports: [MainNotificationComponent],
})
export class MainNotificationModule { }
